import React from 'react'
import { MdOutlineCurrencyRupee } from "react-icons/md";
import { FaHeadphones } from "react-icons/fa";
import { PiClockUserBold } from "react-icons/pi";
import { Helmet } from "react-helmet";


function BharatIntro() {
    return (
        <>
            <Helmet>
                <title>The Best Cab Jaipur – Affordable Taxi, One Way & Outstation Services</title>
                <meta
                    name="description"
                    content="Book reliable and affordable cab services in Jaipur for one-way, round trips, and outstation travel. Explore Rajasthan’s top destinations with our trusted taxi service and tour packages."
                />
                <meta
                    name="keywords"
                    content="Jaipur cab service, one way taxi, round trip taxi, outstation travel, affordable taxi, Rajasthan tours, taxi booking Jaipur"
                />
                <meta name="author" content="The Best Cab Jaipur" />
            </Helmet>
            <section className="container mx-auto px-4 py-12">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                    Book Affordable & Reliable Taxi Services in Jaipur & Across India!
                </h2>
                <p className="text-gray-700 text-md leading-relaxed">
                    Welcome to <strong>The Best Cab by Bharat Tours & Travels</strong>, your premier choice for reliable and affordable taxi services in Jaipur & across India. We specialize in offering a wide range of transportation solutions, including local taxi services, outstation cabs, airport transfers, and customized tour packages tailored to your travel needs.
                </p>
                <p className="text-gray-700 text-md leading-relaxed mt-4">
                    Our fleet comprises well-maintained vehicles, and our professional drivers are dedicated to ensuring a safe and comfortable journey for every passenger. Whether you're planning a city tour in Jaipur, need a taxi service near you, or require an airport taxi service, our 24/7 taxi service is here to provide seamless travel experiences.
                </p>
                <p className="text-gray-700 text-md leading-relaxed mt-4">
                    Book your ride easily through our online cab booking platform and enjoy transparent pricing with no hidden charges.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
                    <div
                        className="p-8 rounded-2xl shadow-2xl text-white transition-transform duration-300 hover:scale-105 flex flex-col items-center text-center bg-pink-600"
                    >
                        <span className="flex items-center justify-center w-12 h-12 bg-white text-pink-600 text-3xl rounded-xl shadow-md">
                            <MdOutlineCurrencyRupee />
                        </span>
                        <h3 className="text-2xl mt-4 font-semibold drop-shadow-lg">
                            Secure Payment! Hassle-Free Booking
                        </h3>
                    </div>
                    <div
                        className="p-8 rounded-2xl shadow-2xl text-white transition-transform duration-300 hover:scale-105 flex flex-col items-center text-center bg-pink-600"
                    >
                        <span className="flex items-center justify-center w-12 h-12 bg-white text-pink-600 text-3xl rounded-xl shadow-md">
                            <FaHeadphones />
                        </span>
                        <h3 className="text-2xl mt-4 font-semibold drop-shadow-lg">
                            24/7 Dedicated Support & Speedy Solutions
                        </h3>
                    </div>
                    <div
                        className="p-8 rounded-2xl shadow-2xl text-white transition-transform duration-300 hover:scale-105 flex flex-col items-center text-center bg-pink-600"
                    >
                        <span className="flex items-center justify-center w-12 h-12 bg-white text-pink-600 text-3xl rounded-xl shadow-md">
                            <PiClockUserBold />
                        </span>
                        <h3 className="text-2xl mt-4 font-semibold drop-shadow-lg">
                            Never Late, Always Great Rides!
                        </h3>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BharatIntro